import { render } from "./DateType.vue?vue&type=template&id=51c506dc&scoped=true"
import script from "./DateType.vue?vue&type=script&lang=js"
export * from "./DateType.vue?vue&type=script&lang=js"

import "./DateType.vue?vue&type=style&index=0&id=51c506dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c506dc"]])

export default __exports__